import { useEffect, useState } from 'react'
import { getConfig } from '../config/gameConfig';
import { trackProgress } from '../utils/progressApi';

export default function Timer({ setStop, questionNumber, timerActive, setTimerWarning, userName, questionSet, currentQuestion, timerDuration, resetTrigger }) {
    const [timer, setTimer] = useState(timerDuration || 20);
    const warningTime = getConfig('warningTime');

    useEffect(() => {
        if (!timerActive) return;
        // if the timer elapses, stop the quiz 
        if (timer === 0) {
            // Track timer expiration as an error
            const trackTimerExpiration = async () => {
                const correctAnswer = currentQuestion?.answers?.find(ans => ans.correct);
                await trackProgress({
                    username: userName,
                    questionset: questionSet,
                    action: 'error',
                    question: `Q${questionNumber}: ${currentQuestion?.question || 'Unknown question'}`,
                    answer: 'timeout',
                    notes: correctAnswer ? `Timer expired. Correct answer: ${correctAnswer.text}` : 'Timer expired'
                });
            };
            
            trackTimerExpiration();
            return setStop(true);
        }
        const interval = setInterval(() => {
            setTimer(prev => prev - 1);
        }, 1000);

        return () => clearInterval(interval);
    }, [setStop, timer, timerActive, userName, questionSet, questionNumber, currentQuestion]);

    useEffect(() => {
        // Reset timer when question changes using the timer duration from question set
        setTimer(timerDuration || 20)
    }, [questionNumber, timerDuration])

    useEffect(() => {
        // Reset timer when resetTrigger changes (used for lifeline resets)
        if (resetTrigger !== undefined) {
            setTimer(timerDuration || 20)
        }
    }, [resetTrigger, timerDuration])
    
    // Check if we're in warning time
    const isWarning = timer <= warningTime;
    
    // Update parent component's warning state
    useEffect(() => {
        if (setTimerWarning) {
            setTimerWarning(isWarning);
        }
    }, [isWarning, setTimerWarning]);
    
    // Return JSX with conditional styling
    return (
        <span style={{ 
            color: isWarning ? 'red' : 'white',
            fontWeight: 'bold'
        }}>
            {timer}
        </span>
    );
}
